import { Injectable } from '@angular/core';
import { Resource, ResourceParams, ResourceHandler, ResourceAction, ResourceRequestMethod, IResourceMethodPromise } from '@ngx-resource/core';
import { IMongooseResult } from './api.module';
import { AuthService } from './auth.service';

@ResourceParams({
  pathPrefix: '/api/weborder'
})
@Injectable()
export class WeborderResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: ''
  })
  query: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}'
  })
  getOne: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}/product'
  })
  getProducts: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/finish'
  })
  finish: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/refreshCost'
  })
  refreshCost: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Delete,
    path: '/{!webordernmbr}/product/{!productkey}/sequence/{!sequence}'
  })
  deleteProduct: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!webordernmbr}/product/{!productkey}/sequence/{!sequence}'
  })
  updateProduct: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: ''
  })
  create: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/product/{!productkey}'
  })
  addProduct: IResourceMethodPromise<any, any>;


  getCart(mybusiness: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.query({ mybusiness, 'weborders.weborderstate': '<19' }).then((data) => {
        if (data.results.length > 0) {
          resolve(data.results[0]);
        } else {
          this.create({ mybusiness }).then((newCart) => {
            resolve(newCart);
          }, (err) => {

          });
        }
      }, (err) => { });
    });
  }

}
